import type { FormatterFactory } from '../types';

export interface CellClassOptions {
  className?: string;
  options?: Record<string, string>;
  optionsSource?: 'inputValue' | 'fieldValue';
  value?: (context: any) => string | Record<string, boolean> | null | undefined;
}

export const cellclass: FormatterFactory = (
  options: CellClassOptions = {},
) => ({
  cellClass: (value, context) => {
    if (options.value) {
      return withClassName(options.value(context), options.className);
    }
    if (options.options) {
      const key = value as string | number;
      const mapped = key == null ? undefined : options.options[key];
      return withClassName(mapped, options.className);
    }
    return options.className ?? '';
  },
});

function withClassName(
  resolved: string | Record<string, boolean> | null | undefined,
  className: string | undefined,
): string | Record<string, boolean> {
  if (resolved == null) {
    return className ?? '';
  }
  if (typeof resolved === 'string') {
    return className ? `${resolved} ${className}` : resolved;
  }
  return className ? { ...resolved, [className]: true } : resolved;
}
